import React from 'react';
import AbstractList from "components/lists/AbstractList";
import { ListColumnType, ListFilterType } from "types/ListTypes";
import TimeSheetTimeTypeForm from "./TimeSheetTimeTypeForm";

// Rename the name of the function:
const TimeSheetTimeTypeList: React.FC = () => {

    // Specify the options of this list:
    const query = {
        endpoint: 'get_timesheet_timetype_list',
        defaultParams: { 
            'is_active': true, 
        },
        object: 'timetype'
    }
    const groupByField = {
        field: 'type',
        translateValue: true
    }
    const objectName = 'timetype.general.object_name'
    const showSearch = false
    const showDeleteOrDeactivate = 'flag_deactivated'

    // Set isPaginated to true if this list may have 100.000+ items:
    const isPaginated = false

    // Specify form, detail modal or detailpage for this list
    const formModal = <TimeSheetTimeTypeForm />;
    const onRowClick = 'editModal'

    // Specify the columns of this list:
    const columns: ListColumnType[] = [
        { width: '1fr', field: 'name', label: 'timetype.general.name_label' },
    ];

    // Specify the filters of this list:
    const filters: ListFilterType[] = [
        {
            id: 'active',
            label: 'timetype.general.active_timetypes_label',
            params: { 'is_active': true }
        },
        {
            id: 'inactive',
            label: 'timetype.general.inactive_timetypes_label',
            params: { 'is_active': false }
        }
    ]

    return (
        <AbstractList
            query={query}
            objectName={objectName}
            groupByField={groupByField}
            filters={filters}
            columns={columns}
            showSearch={showSearch}
            showDeleteOrDeactivate={showDeleteOrDeactivate}
            formModal={formModal}
            isPaginated={isPaginated}
            onRowClick={onRowClick}
        />
    );
};

export default TimeSheetTimeTypeList;